<div class="relative">
  <div class="flex items-center">
    <button
      (click)="toggleMenu()"
      class="text-base font-medium text-gray-2 flex items-center gap-1 leading-none"
    >
      Venta verde
      <span class="material-symbols-rounded text-light-blue pt-[2px]"
        >expand_more</span
      >
    </button>
  </div>

  <div
    class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-b-lg bg-white focus:outline-none p-2 text-gray-2 text-smPlus font-light"
    [hidden]="!menuOpen"
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="menu-button"
    tabindex="-1"
  >
    <ul class="flex flex-col gap-4">
      <li *ngIf="['VV-CL-ADMIN', 'VV-CL-ISSUERS'].includes(role)">
        <a
          [routerLink]="['/' + routes.POLICY_CREATE_CREAR_POLIZA]"
          role="menuitem"
          tabindex="-1"
          >Emitir póliza</a
        >
      </li>
      <li *ngIf="['VV-CL-ADMIN', 'VV-CL-PROJECT-CREATOR'].includes(role)" class="relative group">
        <a
          [routerLink]="['/' + routes.MIS_PROYECTOS]"
          class="flex items-center"
          role="menuitem"
          tabindex="-1"
        >
          <span class="material-symbols-rounded -ml-2"> arrow_left </span>
          Mis proyectos</a
        >
        <ul
          class="bg-white rounded-l-lg absolute top-0 -left-36 transition duration-150 ease-in-out origin-top-left hidden group-hover:flex w-36 p-2 flex-col gap-4"
        >
          <li>
            <a [routerLink]="['/' + routes.PROJECT_MIS_PROYECTOS]"
              >Lista de proyectos</a
            >
          </li>
          <li>
            <a [routerLink]="createProjectRoute">Crear proyecto</a>
          </li>
        </ul>
      </li>
      <li *ngIf="['VV-CL-ADMIN', 'VV-CL-ISSUERS'].includes(role)">
        <a
          class="cursor-pointer"
          (click)="routingPolicies('PENDING')"
          role="menuitem"
          tabindex="-1"
          >Pólizas por emitir</a
        >
      </li>
      <li *ngIf="['VV-CL-ADMIN', 'VV-CL-ISSUERS', 'VV-CL-VIEWER'].includes(role)" class="relative group">
        <a
          class="flex items-center"
          role="menuitem"
          tabindex="-1"
        >
          <span class="material-symbols-rounded -ml-2"> arrow_left </span>
          Reportes</a
        >
        <ul
          class="bg-white rounded-l-lg absolute bottom-0 -left-24 transition duration-150 ease-in-out origin-top-left hidden group-hover:flex w-24 p-2 flex-col gap-4"
        >
          <li class="py-1">
            <a [routerLink]="['/' + routes.POLICY_POLICIES]">Mis pólizas</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
